import React from 'react'
import { NeonLogoProps } from './NeonLogoProps'

const NeonLogo: React.FC<NeonLogoProps> = ({className}: NeonLogoProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 59.177 23"
      className={className}
    >
      <g id="Neon-logo-hoz-wht-rgb" transform="translate(29.589 11.5)">
        <g
          id="Neon-logo-hoz-wht-rgb-2"
          data-name="Neon-logo-hoz-wht-rgb"
          transform="translate(-29.589 -11.5)"
        >
          <path
            id="Path_583"
            data-name="Path 583"
            d="M113.464,78.28H56.382a1.073,1.073,0,0,1-1.072-1.072V56.353a1.073,1.073,0,0,1,1.072-1.073h57.032a1.074,1.074,0,0,1,1.073,1.073v15.26a1,1,0,0,1-2,0V57.275H57.3V76.285h56.16a1,1,0,0,1,0,2Z"
            transform="translate(-55.31 -55.28)"
            fill="#fff"
          />
          <path
            id="Path_584"
            data-name="Path 584"
            d="M336.06,152.845v-9.487a1.027,1.027,0,0,1,1.027-1.028h8.03a.927.927,0,0,1,.936.952.9.9,0,0,1-.906.863h-7.054a.005.005,0,0,0-.005.005v2.991a0,0,0,0,0,0,0h6.392a.922.922,0,0,1,.908.941.908.908,0,0,1-.915.873H338.09a0,0,0,0,0,0,0v3.09a0,0,0,0,0,0,0h7.11a.927.927,0,0,1,.937.952.9.9,0,0,1-.906.863h-8.143a1.027,1.027,0,0,1-1.027-1.029Z"
            transform="translate(-317.57 -136.597)"
            fill="#fff"
          />
          <path
            id="Path_585"
            data-name="Path 585"
            d="M150.875,152.307a.993.993,0,0,0,.186-.49c.017-.157,0-9.655.005-9.8a1,1,0,0,0-2,0v6.944l-6.3-7.579a1.066,1.066,0,0,0-.218-.2,1,1,0,0,0-1.507.545,1.05,1.05,0,0,0-.042.286v9.705a1,1,0,1,0,2,0v-6.943l6.3,7.578a1.107,1.107,0,0,0,.151.148A1,1,0,0,0,150.875,152.307Z"
            transform="translate(-135.357 -135.373)"
            fill="#fff"
          />
          <path
            id="Path_586"
            data-name="Path 586"
            d="M506.92,146.748v-.033a5.92,5.92,0,0,1,11.84-.032v.032a5.92,5.92,0,0,1-11.84.033Zm9.753,0v-.033a3.879,3.879,0,0,0-3.849-4.027,3.827,3.827,0,0,0-3.82,3.995v.032a3.865,3.865,0,0,0,3.849,4.011,3.813,3.813,0,0,0,3.819-3.978Z"
            transform="translate(-477.178 -135.224)"
            fill="#fff"
          />
          <path
            id="Path_587"
            data-name="Path 587"
            d="M725.236,152.257a1,1,0,0,0,.186-.49c.016-.157,0-9.655,0-9.8a1,1,0,1,0-2,0v6.944l-6.3-7.579a1.084,1.084,0,0,0-.218-.2,1,1,0,0,0-1.51.547,1.1,1.1,0,0,0-.042.286v9.7a1,1,0,0,0,2,0v-6.946l6.3,7.578a1.065,1.065,0,0,0,.151.148A1,1,0,0,0,725.236,152.257Z"
            transform="translate(-671.891 -135.327)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  )
}

export default NeonLogo
